import React from 'react';
import PropTypes from 'prop-types';
import style from './index.css';

const { formatImage, formatUrl } = require('@ifeng-fe/public_method');

class ColumnIntro extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    render() {
        const { content } = this.props;
        const { logo, QRCode, title, description, qr_title } = content;

        const descriptionArr = description ? description.trim().split('\n') : [];

        /**
         * 组件分发数据
         */

        return (
            <div className={style.column}>
                <div className={style.tit}>栏目介绍</div>
                {logo ? (
                    <div className={style.column_pic}>
                        <img style={{ width: '124px' }} src={formatUrl(logo)} />
                    </div>
                ) : (
                    ''
                )}
                <p className={style.intro_p}>
                    {descriptionArr.length > 0
                        ? descriptionArr.map((item, index) => <span key={index}>{item}</span>)
                        : ''}
                </p>
                {QRCode ? (
                    <div>
                        <i>
                            <img src={formatImage(QRCode, 102, 102)} />
                        </i>
                        <span>
                            扫描二维码<br />关注{qr_title || title}微信
                        </span>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default ColumnIntro;
